/**
 * @desc pms-通过pono和sku获取报价信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierQuotationFacadeImpl.getDetailByPonoAndSku.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/getDetailByPonoAndSku`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
